import { DEFAULT_DATE_FORMAT } from '@shared/constants';

export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: DEFAULT_DATE_FORMAT,
  },
  display: {
    dateInput: DEFAULT_DATE_FORMAT,
    monthYearLabel: 'MMM yyyy',
    dateA11yLabel: DEFAULT_DATE_FORMAT,
    monthYearA11yLabel: 'MMMM yyyy',
  },
};
